import React, { ChangeEvent, FunctionComponent, InputHTMLAttributes, useCallback } from 'react';
import styles from './styles.module.scss';
import { useFallbackId } from '../../useFallbackId';
import { RequiredProps } from '../Label';
import classNames from 'classnames';

export type CheckboxProps = {
    id?: string;
    label?: string;
    isChecked: boolean;
    onChange: (checked: boolean) => void;
} & Omit<InputHTMLAttributes<HTMLInputElement>, 'type' | 'checked' | 'onChange'> &
    RequiredProps;

export const Checkbox: FunctionComponent<CheckboxProps> = ({
    id,
    label,
    isChecked,
    onChange,
    required,
    requiredStrategy,
    className,
    ...inputProps
}) => {
    const inputId = useFallbackId(id);

    const handleChange = useCallback(
        (event: ChangeEvent<HTMLInputElement>) => {
            onChange(event.target.checked);
        },
        [onChange]
    );

    return (
        <label
            htmlFor={inputId}
            className={classNames(styles.checkboxContainer, className)}
            data-required={required}
            data-required-strategy={requiredStrategy}
        >
            {label}
            <input
                id={inputId}
                className="screen_reader_hidden"
                type="checkbox"
                checked={isChecked}
                onChange={handleChange}
                {...inputProps}
            />
            <span className={styles.checkbox}></span>
        </label>
    );
};

export default Checkbox;
